export default "__VITE_ASSET__Dv$e31sv__"